/*
* vux 插件初始化 并且自定义
*
* */


import Vue from 'vue'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import dateFormat from 'vux/src/tools/date/format.js'

import qs from 'qs' 
Vue.use(AjaxPlugin) 
Vue.use(WechatPlugin) 
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)

export default () => {


Vue.http.interceptors.request.use(function (config) {

if (config.method == 'get') {

} else {
Vue.http.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
config.data = qs.stringify(config.data)
}

return config;
}, function (error) {
return Promise.reject(error);
});


Vue.http.interceptors.response.use(function (response) {

return response;
}, function (error) {
Vue.$vux.toast.show({
text: '请您检查网络',
position: 'top',
type:'text',
width:'5rem'
})
return Promise.reject(error);
});

}



// WEBPACK FOOTER //
// ./src/public/VuxConfig.js